import React from "react";
import styled from "styled-components";
import { LogOut, Settings as SettingsIcon } from "lucide-react";
import { Button } from "../common/Button";
import { signOut } from "../../services/auth";
import { useNavigate } from "react-router-dom";
import { AvatarUpload } from "./AvatarUpload";

const ProfileHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  margin-bottom: var(--spacing-6);
`;


const UserInfo = styled.div`
  flex: 1;
  margin-top: 32px;
`;

const UserName = styled.h1`
  font-size: 2rem;
  margin-bottom: var(--spacing-2);
  color: var(--color-text-primary);
`;

const UserEmail = styled.p`
  color: var(--color-text-secondary);
  font-size: 1.1rem;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: var(--spacing-3);
  margin-top: var(--spacing-4);
`;

interface ProfileHeaderProps {
  user: {
    displayName: string;
    email: string;
    photoURL?: string;
  };
  onAvatarUpdate: (url: string) => void;
  onSettingsClick: () => void;
  showSettings: boolean;
}

export const ProfileHeader = ({
  user,
  onAvatarUpdate,
  onSettingsClick,
  showSettings,
}: ProfileHeaderProps) => {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <ProfileHeaderContainer>
      <AvatarUpload
        currentPhotoURL={user.photoURL}
        onAvatarUpdate={onAvatarUpdate}
      />
      <UserInfo>
        <UserName>{user.displayName}</UserName>
        <UserEmail>{user.email}</UserEmail>
        <ActionButtons>
          <Button
            variant="secondary"
            onClick={onSettingsClick}
            icon={<SettingsIcon size={18} />}
          >
            {showSettings ? 'Fermer les paramètres' : 'Paramètres'}
          </Button>
          <Button
            variant="danger"
            onClick={handleSignOut}
            icon={<LogOut size={18} />}
          >
            Se déconnecter
          </Button>
        </ActionButtons>
      </UserInfo>
    </ProfileHeaderContainer>
  );
};
